import { useSyncExternalStore } from "react";
import { docManager, type SyncStatus } from "./docManager";

export function useSyncStatus(): SyncStatus {
  return useSyncExternalStore(
    (cb) => docManager.subscribeStatus(cb),
    () => docManager.getStatus(),
    () => "offline" as SyncStatus,
  );
}

/** True from a lost connection until everything is synced again, without flickering in between. */
export function useSyncOutage(): boolean {
  return useSyncExternalStore(
    (cb) => docManager.subscribeStatus(cb),
    () => docManager.isOutage(),
    () => false,
  );
}
